var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsightsOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill or Outline=Yes",
    clipPath: "url(#clip0_10047_17999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7635 6.66263L12.713 12.713L11.287 11.287L17.3374 5.23653L18.7635 6.66263Z",
    fill: "var(--primary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45378 12C6.45378 12.7797 5.82171 13.4118 5.04202 13.4118H3.42857V10.5882H5.04202C5.82171 10.5882 6.45378 11.2203 6.45378 12Z",
    fill: "var(--primary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5462 12C17.5462 12.7797 18.1783 13.4118 18.958 13.4118H20.5714V10.5882H18.958C18.1783 10.5882 17.5462 11.2203 17.5462 12Z",
    fill: "var(--primary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 6.55462C11.2202 6.55462 10.5881 5.92255 10.5881 5.14286V3.52941L13.4117 3.52941V5.14286C13.4117 5.92255 12.7796 6.55462 11.9999 6.55462Z",
    fill: "var(--primary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83002 7.79783C7.27869 8.34915 6.38481 8.34915 5.83348 7.79782L4.6926 6.65695L6.68914 4.66041L7.83002 5.80129C8.38135 6.35262 8.38135 7.2465 7.83002 7.79783Z",
    fill: "var(--primary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.81513C6.37505 1.81513 1.81513 6.37505 1.81513 12C1.81513 17.625 6.37505 22.1849 12 22.1849C17.625 22.1849 22.1849 17.625 22.1849 12C22.1849 6.37505 17.625 1.81513 12 1.81513ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "var(--primary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0252 12C15.0252 13.6708 13.6708 15.0252 12 15.0252C10.3292 15.0252 8.97479 13.6708 8.97479 12C8.97479 10.3292 10.3292 8.97479 12 8.97479C13.6708 8.97479 15.0252 10.3292 15.0252 12Z",
    fill: "var(--primary-6)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10047_17999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--white)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsOutlined);
export default __webpack_public_path__ + "static/media/insightsOutlined.951d5a9414514cfee7612067c2ba2b3c.svg";
export { ForwardRef as ReactComponent };